/* src/app/components/password-reset/password-reset.component.scss */
:host {
  display: block;
  min-height: 100vh;
}
.password-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(
      circle at 8% 8%,
      rgba(37, 59, 128, 0.07),
      transparent 28%),
    radial-gradient(
      circle at 92% 92%,
      rgba(52, 79, 145, 0.06),
      transparent 28%),
    #F4F6FA;
}
.password-shell {
  width: 100%;
  min-height: 100vh;
  display: grid;
  grid-template-columns: 50% 50%;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.07);
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.1), 0 4px 16px rgba(15, 23, 42, 0.04);
}
.password-visual {
  position: relative;
  overflow: hidden;
  background: #dfe8fa;
  color: #ffffff;
}
.password-visual::before {
  content: "";
  position: absolute;
  width: 420px;
  height: 420px;
  top: -180px;
  left: -180px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.07);
}
.password-visual::after {
  content: "";
  position: absolute;
  width: 360px;
  height: 360px;
  right: -170px;
  bottom: -170px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
}
.visual-content {
  position: relative;
  z-index: 1;
  height: 100%;
  padding: 42px;
  display: flex;
  flex-direction: column;
}
.visual-brand {
  display: flex;
  align-items: center;
}
.visual-brand img {
  width: 225px;
  height: auto;
  max-width: 100%;
  filter: brightness(0) invert(1);
}
.visual-image {
  flex: 1;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
}
.visual-image img {
  display: block;
  width: min(100%, 440px);
  max-height: 440px;
  object-fit: contain;
  filter: drop-shadow(0 18px 28px rgba(0, 0, 0, 0.12));
}
.visual-footer {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-top: 20px;
}
.visual-footer span {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  color: #253b80;
}
.visual-footer i {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  font-size: 14px;
}
.password-panel {
  overflow-y: auto;
  background: #ffffff;
}
.password-content {
  width: min(500px, 100%);
  min-height: 100%;
  margin: 0 auto;
  padding: 60px 54px 38px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.mobile-brand {
  margin-bottom: 32px;
}
.mobile-brand img {
  width: 250px;
  height: auto;
}
.password-header {
  margin-bottom: 30px;
}
.password-header h2 {
  margin: 0 0 10px;
  font-family: "Outfit";
  font-size: 30px;
  font-weight: 700;
  line-height: 1.25;
  color: #111827;
}
.password-header p {
  max-width: 430px;
  margin: 0;
  font-family: "Outfit";
  font-size: 15px;
  line-height: 1.6;
  color: #6B7280;
}
.password-alert {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 24px;
  padding: 13px 14px;
  border: 1px solid rgba(220, 38, 38, 0.18);
  border-radius: 10px;
  background: #fef2f2;
}
.alert-icon {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dc2626;
}
.alert-icon i {
  font-size: 16px;
}
.alert-message {
  flex: 1;
  padding-top: 2px;
  font-family: "Outfit";
  font-size: 13px;
  line-height: 1.45;
  color: #991b1b;
}
.alert-close {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #991b1b;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.alert-close:hover {
  background: rgba(220, 38, 38, 0.08);
}
.password-form-wrapper {
  width: 100%;
}
.password-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.form-field {
  width: 100%;
}
.form-field label {
  display: block;
  margin-bottom: 9px !important;
  font-family: "Outfit";
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  color: #111827;
}
.input-wrapper {
  position: relative;
  width: 100%;
}
.input-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  z-index: 1;
  transform: translateY(-50%);
  font-size: 16px;
  color: #94a3b8;
  pointer-events: none;
  transition: color 0.2s ease;
}
.form-input {
  width: 100%;
  height: 50px;
  padding: 0 15px 0 44px;
  box-sizing: border-box;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  outline: none;
  background: #ffffff;
  color: #111827;
  font-family: "Outfit";
  font-size: 15px;
  line-height: 1.4;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;
}
.form-input::placeholder {
  color: #9ca3af;
  opacity: 1;
}
.form-input:hover {
  border-color: #aeb8c8;
}
.form-input:focus {
  border-color: #253B80;
  background: #fbfcff;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.1);
}
.input-wrapper:focus-within .input-icon {
  color: #253B80;
}
.password-error {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: -4px 0 0;
  font-family: "Outfit";
  font-size: 13px;
  line-height: 1.5;
  color: #dc2626;
}
.password-error i {
  flex: 0 0 auto;
  margin-top: 2px;
  font-size: 13px;
}
.password-button {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 3px;
  border: 0;
  border-radius: 10px;
  background: #253B80;
  color: #ffffff;
  font-family: "Outfit";
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 14px rgba(37, 59, 128, 0.18);
  transition:
    background-color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease,
    opacity 0.2s ease;
}
.password-button:hover:not(:disabled) {
  background: #1e316d;
  transform: translateY(-1px);
  box-shadow: 0 9px 20px rgba(37, 59, 128, 0.22);
}
.password-button:active:not(:disabled) {
  transform: translateY(0);
}
.password-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}
.password-button i {
  font-size: 14px;
}
.success-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.success-icon {
  width: 68px;
  height: 68px;
  margin-bottom: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #ecfdf3;
  color: #16a34a;
  box-shadow: 0 0 0 8px rgba(22, 163, 74, 0.06);
}
.success-icon i {
  font-size: 29px;
  font-weight: 700;
}
.success-wrapper h3 {
  margin: 0 0 10px;
  font-family: "Outfit";
  font-size: 27px;
  font-weight: 700;
  line-height: 1.3;
  color: #111827;
}
.success-wrapper p {
  max-width: 420px;
  margin: 0 0 26px;
  font-family: "Outfit";
  font-size: 15px;
  line-height: 1.6;
  color: #6B7280;
}
.password-security {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 28px;
  padding-top: 18px;
  border-top: 1px solid #eef2f7;
  font-family: "Outfit";
  font-size: 13px;
  line-height: 1.4;
  color: #9CA3AF;
}
.password-security i {
  font-size: 13px;
  color: #64748b;
}
@media (max-width: 1024px) {
  .password-page {
    padding: 24px;
  }
  .password-shell {
    grid-template-columns: 40% 60%;
  }
  .visual-content {
    padding: 32px;
  }
  .password-content {
    padding: 50px 42px 36px;
  }
  .password-header h2 {
    font-size: 28px;
  }
  .success-wrapper h3 {
    font-size: 25px;
  }
}
@media (max-width: 800px) {
  .password-page {
    padding: 20px;
  }
  .password-shell {
    grid-template-columns: 1fr;
    max-width: 620px;
    min-height: auto;
  }
  .password-visual {
    display: none;
  }
  .password-content {
    width: 100%;
    min-height: auto;
    padding: 44px 42px 38px;
  }
  .mobile-brand {
    display: block;
    margin-bottom: 32px;
  }
}
@media (max-width: 600px) {
  .password-page {
    padding: 0;
    align-items: stretch;
  }
  .password-shell {
    width: 100%;
    min-height: 100vh;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }
  .password-content {
    padding: 30px 22px 28px;
  }
  .mobile-brand {
    margin-bottom: 30px;
  }
  .mobile-brand img {
    width: 145px;
  }
  .password-header {
    margin-bottom: 26px;
  }
  .password-header h2 {
    font-size: 26px;
    line-height: 1.25;
  }
  .password-header p {
    font-size: 14px;
    line-height: 1.6;
  }
  .form-field label {
    font-size: 13px;
  }
  .form-input {
    height: 50px;
    font-size: 14px;
  }
  .password-button {
    height: 50px;
    font-size: 14px;
  }
  .password-error {
    font-size: 12px;
  }
  .success-icon {
    width: 62px;
    height: 62px;
  }
  .success-icon i {
    font-size: 26px;
  }
  .success-wrapper h3 {
    font-size: 24px;
  }
  .success-wrapper p {
    font-size: 14px;
  }
  .password-security {
    font-size: 12px;
  }
}
@media (max-width: 380px) {
  .password-content {
    padding: 26px 18px 24px;
  }
  .password-header h2 {
    font-size: 24px;
  }
  .password-header p {
    font-size: 13px;
  }
  .form-input,
  .password-button {
    height: 48px;
  }
  .success-wrapper h3 {
    font-size: 22px;
  }
  .success-wrapper p {
    font-size: 13px;
  }
}
/*# sourceMappingURL=password-reset.component.css.map */
